import { Select as _Select } from './Select';
import { SelectDivider } from './Select.Divider';
import { SelectFooter } from './Select.Footer';
import { SelectLabel } from './Select.Label';
import { SelectList } from './Select.List';
import { SelectOption } from './Select.Option';
import { SelectSection } from './Select.Section';

export type { ISelectProps } from './Select';
export type { ISelectOptionProps } from './Select.Option';
export type { ISelectLabelProps } from './Select.Label';

export const Select = Object.assign(_Select, {
  Footer: SelectFooter,
  Option: SelectOption,
  List: SelectList,
  Label: SelectLabel,
  Divider: SelectDivider,
  Section: SelectSection
});
